"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOloVendorBodyToJSON = exports.UpdateOloVendorBodyFromJSONTyped = exports.UpdateOloVendorBodyFromJSON = void 0;
function UpdateOloVendorBodyFromJSON(json) {
    return UpdateOloVendorBodyFromJSONTyped(json, false);
}
exports.UpdateOloVendorBodyFromJSON = UpdateOloVendorBodyFromJSON;
function UpdateOloVendorBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'oloVendorId': json['oloVendorId'],
    };
}
exports.UpdateOloVendorBodyFromJSONTyped = UpdateOloVendorBodyFromJSONTyped;
function UpdateOloVendorBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'oloVendorId': value.oloVendorId,
    };
}
exports.UpdateOloVendorBodyToJSON = UpdateOloVendorBodyToJSON;
